import { useEffect } from "react";

/**
 * Host-controlled open state (`env.open`): when the host flips the prop, open or
 * close the panel exactly as the launcher would (`openPanel` keeps the auth
 * guards). `undefined` leaves the widget uncontrolled. Driven by prop CHANGES
 * only: the widget's own open/close (launcher, X, Escape) reports through
 * `onOpen` / `onClose`, which the host mirrors back into `open`, so there is no
 * feedback loop and each transition is reported once.
 */
export function useHostOpen(
  open: boolean | undefined,
  openPanel: () => void,
  closePanel: () => void,
) {
  useEffect(() => {
    if (open === undefined) return;
    if (open) openPanel();
    else closePanel();
  }, [open, openPanel, closePanel]);
}
